import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Button } from '@cian/ui-kit';

import { getReviews, getReviewsStats } from '../../selectors/developerV2';
import { ReviewAuthor } from '../../components/ReviewCommon/ReviewAuthor';
import { ReviewAnswers } from '../../components/ReviewCommon/ReviewAnswers';

import { ReviewsTeaserLayout } from '../../components/ReviewsTeaserMobile/ReviewsTeaserLayout';
import { ReviewsTitle } from '../../components/ReviewsTeaserMobile/parts/Teaser/ReviewsTitle';
import { ReviewItem } from '../../components/ReviewsTeaserMobile/parts/ReviewItem';
import { ReviewsFooter } from '../../components/ReviewsTeaserMobile/parts/Teaser/ReviewsFooter';

import { ReviewComment } from '../../components/ReviewsTeaserMobile/parts/ReviewComment';

import { ReviewsReactionsContainer } from '../ReviewsReactionsContainer';

import { trackAllReviewsClick, trackReviewsClick } from '../Reviews/tracking';
import { setReviewDetailsOpenAction } from '../../actions/reviewsDetails/actions';
import { VerticalScrollable } from '../../components/VerticalScrollable';
import { RatingsRedesigned } from '../../components/RatingsRedesigned';
import { pluralize } from '@cian/newbuilding-utils';

export const ReviewsTeaserMobileContainer: React.FC = () => {
  const dispatch = useDispatch();
  const reviews = useSelector(getReviews);
  const { reviewCountText, totalRate, reviewCount } = useSelector(getReviewsStats);

  const onReadAllClick = React.useCallback(() => {
    trackAllReviewsClick();
    dispatch(setReviewDetailsOpenAction({ reviewId: null }));
  }, []);

  const onReviewItemClick = React.useCallback((reviewId: string) => {
    trackReviewsClick();
    dispatch(setReviewDetailsOpenAction({ reviewId }));
  }, []);

  const buttonText = React.useMemo(() => {
    const count = reviews.length;

    return `Показать ${pluralize(count, ['популярный отзыв', 'популярных отзыва', 'популярных отзывов'])}`;
  }, [reviews]);

  return (
    <ReviewsTeaserLayout>
      <ReviewsTitle
        reviewCount={reviewCount}
        title="Средняя оценка по отзывам на ЖК"
        rating={<RatingsRedesigned reviewCountText={reviewCountText} totalRate={totalRate} reviewCount={reviewCount} />}
      />

      <VerticalScrollable horizontalAlign={true}>
        {reviews.map(
          ({ id, url, user, date, isLegacy, comment, rating, answersCount, newbuildingName, newbuildingUrl, like }) => (
            <ReviewItem
              key={id}
              author={
                <ReviewAuthor
                  newbuildingName={newbuildingName}
                  newbuildingUrl={newbuildingUrl}
                  avatarUrl={user.avatarUrl}
                  name={user.name}
                  date={date}
                  rating={rating}
                />
              }
              comment={
                <ReviewComment
                  isLegacy={isLegacy}
                  comment={comment}
                  onReadFullReviewClick={() => onReviewItemClick(id)}
                />
              }
              answers={<ReviewAnswers url={url} answersCount={answersCount} />}
              reaction={<ReviewsReactionsContainer reviewId={id} reactions={like} />}
            />
          ),
        )}
      </VerticalScrollable>
      <ReviewsFooter>
        <Button theme="fill_secondary" fullWidth={true} onClick={onReadAllClick}>
          {buttonText}
        </Button>
      </ReviewsFooter>
    </ReviewsTeaserLayout>
  );
};
